{
    "LockedOut": "Utente bloccato:",
    "PromptTos": "Termini di servizio di Prompt:",
    "NotifyPasswordChange": "Notificare la modifica della password:",
    "UpdateInterval": "Intervallo di aggiornamento del rapporto:",
    "UpdateIntervalCharacter": "s",
    "UpdateIntervalValidation": "L'intervallo di aggiornamento dei rapporti ha un massimo di 180 secondi",
    "MediaPlayer": "Disattivare i plug-in di Media Player:",
    "DragAndDrop": "Funzionalità di trascinamento disabilitate:",
    "JavascriptOutput": "Output di controllo JavaScript:",
    "AutoValue": "[Auto]",
    "SettingsLanguage_ServiceNotification": "Notifica di servizio:",
    "SettingsLanguage_ConcurrentSignins": "Sono consentite insegne contemporanee:",
    "SettingsLanguage_AdvancedTitle": "Diagnostica avanzata",
    "NAME": "SettingsLanguage",
    "SettingsLanguage_AuthNotifications": "Notifica di autorizzazione:",
    "SettingsLanguage_NewDeviceNotifications": "Notifiche di provisioning:",
    "SettingsLanguage_AuthNotifications_Help": "Abilitando le notifiche di autorizzazione, l'amministratore riceverà un messaggio di posta elettronica quando l'autorizzazione di un server di telefonia MS Teams è andata a buon fine.",
    "SettingsLanguage_NewDeviceNotifications_Help": "Abilitando le notifiche di provisioning, l'amministratore riceverà un'e-mail quando viene aggiunto un nuovo dispositivo o viene modificata la modalità di integrazione su un'istanza MS Teams."
}